import React from "react";
import { Navigate } from "react-router-dom";


function RestrictedRoute({ children }) {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
}

export default RestrictedRoute;